export const BASE_URL = 'externalCompanies';

export const PATHS = {
  BASE_URL,
};

export const FORMS = {
  EXTERNAL_COMPANY: 'externalCompany',
  SUPERVISORS: 'supervisors',
  USERS: 'users',
};
